import { ReactNode } from 'react';
import { Stack as MuiStack, StackProps as MuiStackProps } from '@mui/material';

export interface StackProps extends MuiStackProps {
  children?: ReactNode;
}

export const Stack = ({ children, ...props }: StackProps) => {
  return <MuiStack {...props}>{children}</MuiStack>;
};
